/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Api_KeyInputs */

const cs_enum_api_key = /** @type {(inputs: Enum_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API klíč`)
};

const en_enum_api_key = /** @type {(inputs: Enum_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key`)
};

/**
* | output |
* | --- |
* | "API key" |
*
* @param {Enum_Api_KeyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_api_key = /** @type {((inputs?: Enum_Api_KeyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Api_KeyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_api_key(inputs)
	return cs_enum_api_key(inputs)
});